import { render, staticRenderFns } from "./IfThisIsAManTheTruceArticle.vue?vue&type=template&id=da35942c&"
import script from "./IfThisIsAManTheTruceArticle.vue?vue&type=script&lang=js&"
export * from "./IfThisIsAManTheTruceArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports